import EmplacementsTab from "@features/stock/components/EmplacementsTab";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/stock/emplacements/")({
  component: EmplacementsTab,
});
